import axios from 'axios';
import { serialize } from 'object-to-formdata';

const pathBaseVacancy = '/app/vacancy';

function _buildFormatData(data) {
  const formData = new FormData();
  const json = JSON.stringify(data);
  const blob = new Blob([json], {
    type: 'application/json'
  });
  formData.append('vacancy', blob);
  if (data.img_vacancy) {
    formData.append('img_name', data.img_vacancy);
  }
  return formData;
}

export function createVacancy(data) {
  const formData = _buildFormatData(data);

  return axios.post(`${pathBaseVacancy}/createVacancy/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export function updateVacancy(data) {
  const formData = _buildFormatData(data);

  return axios.post(`${pathBaseVacancy}/updateVacancy/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function createDrafVacancy(data) {
  const formData = _buildFormatData(data);

  return axios.post(`${pathBaseVacancy}/createDrafVacancy/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function updateDrafVacancy(data) {
  const formData = _buildFormatData(data);

  return axios.post(`${pathBaseVacancy}/updateDrafVacancy/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function getVacancy(id) {
  return axios.get(`${pathBaseVacancy}/getVacancyApi/${id}`);
}

export function updatedVacancy(id, data) {
  const formData = _buildFormatData(data);

  return axios.post(`${pathBaseVacancy}/updateVacancyApi/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function addAccountLogo(data) {
  const fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]); // formdata doesn't take objects
  }
  return axios.post(`${pathBaseVacancy}/add_account_logo2/`, fd, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function removelogo(data) {
  return axios.post(`${pathBaseVacancy}/remove_logo/`, data);
}
export function getIaContent(data) {
  return axios.post(`${pathBaseVacancy}/getIADescription`, serialize(data));
}

export function getMetricsForDescription(data) {
  return axios.post(`/api/vacancies/iaMetricsForDescriptionField`, serialize(data));
}

export function getProvinces() {
  return axios.get(`${pathBaseVacancy}/getProvinces/`);
}

export function getCountryLocalities() {
  return axios.get(`${pathBaseVacancy}/getCountryLocalities/`);
}

export function getCountries() {
  return axios.get(`${pathBaseVacancy}/getCountries/`);
}

export function getLogos() {
  return axios.get(`${pathBaseVacancy}/getLogos/`);
}

export function getVacanciesDuplicateContent() {
  return axios.get(`${pathBaseVacancy}/getVacanciesDuplicateContent`);
}

export function getAutorization(data) {
  return axios.post(`/oauth2/authorization`, data);
}

export function putLocalities(data) {
  return axios.post(`${pathBaseVacancy}/putLocalities`, data);
}

export function postLocalities(data, id) {
  return axios.post(`${pathBaseVacancy}/postLocalities/${id}`, data);
}

export function deleteLocalities(id) {
  return axios.post(`${pathBaseVacancy}/deleteLocalities/${id}`);
}

export function getLocalitiesRelations(id) {
  return axios.post(`${pathBaseVacancy}/getLocalitiesRelations/${id}`);
}

export function getLocality(id) {
  return axios.post(`${pathBaseVacancy}/getLocality/${id}`);
}

export function putAreas(data) {
  return axios.post(`${pathBaseVacancy}/putAreas`, data);
}

export function putClients(data) {
  return axios.post(`${pathBaseVacancy}/putClients`, data);
}

export function createPipeline(data) {
  return axios.post(`/app/pipelines/create_template`, data);
}

export function checkSessionExpired(data) {
  return axios.post(`/app/main/checkTimeSession`, {});
}

export function getQuestionsForIa(data) {
  return axios.post(`${pathBaseVacancy}/getIAQuestions`, serialize(data));
}
